import { render, staticRenderFns } from "./Variant.vue?vue&type=template&id=140a0614&scoped=true"
import script from "@/views/Variants/Variant.ts?vue&type=script&lang=ts&external"
export * from "@/views/Variants/Variant.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Variants/variant.scss?vue&type=style&index=0&id=140a0614&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140a0614",
  null
  
)

export default component.exports